import React, { useState, useEffect, useCallback } from "react";
import { Grid } from "@mui/material";

import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import NativeObject from "../../components/NativeObject/NativeObject";
import { Footer } from "../../components/Footer/Footer";
import Card from "../../components/Cards/Card";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";

const NATIVE_OBJECTS = {
  BIG_NUMBERS: {
    OPORT: "ZYbkFf",
    CO_FOR: "FHNJAH",
    CO_QUA: "txNqf",
    SELL: "PLkbAwd",
  },
  DISTRI: "WmXXbR",
  PARTIC: "YxxYT",
};

function InsightsDesktop({ app }) {
  const [porcentage, setPorcentage] = useState();
  const [cobeturaFormatos, setCobeturaFormatos] = useState();
  const [cobeturaQualificada, setCobeturaQualificada] = useState();
  const [sellOutTotal, setSellOutTotal] = useState();

  const getValueInfoBigNumber = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          position === 1 && setPorcentage(value);
          position === 2 && setCobeturaFormatos(value);
          position === 3 && setCobeturaQualificada(value);
          position === 4 && setSellOutTotal(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );
  useEffect(() => {
    getValueInfoBigNumber(NATIVE_OBJECTS.BIG_NUMBERS.OPORT, 1);
    getValueInfoBigNumber(NATIVE_OBJECTS.BIG_NUMBERS.CO_FOR, 2);
    getValueInfoBigNumber(NATIVE_OBJECTS.BIG_NUMBERS.CO_QUA, 3);
    getValueInfoBigNumber(NATIVE_OBJECTS.BIG_NUMBERS.SELL, 4);
  }, [app, getValueInfoBigNumber]);

  return (
    <div className="app insights">
      <div className="appContent">
        <LayoutWrapper>
          <Grid>
            <Card
              className="container-card-only-title"
              style={{ margin: "0 0 2.9px 0" }}
            >
              <h1 className="title">Insights</h1>
            </Card>
          </Grid>
          <Grid className="container-bignumbers">
            <Card
              header={{
                hardTitle: "Oportunidades",
              }}
            >
              <div className="bignumber-subTitle">
                Distribuidores abaixo da média mensal
              </div>

              <div className="bignumber-values">{porcentage}</div>

              <div className="bignumber-footer">
                <EastOutlinedIcon
                  color="#173354"
                  sx={{ width: 16, height: 16 }}
                />
                <span>Maior potencial de compra</span>
              </div>
            </Card>

            <Card
              header={{
                hardTitle: "Cobertura Formatos",
              }}
            >
              <div className="bignumber-subTitle">
                Melhor PDV em cobertura DLX
              </div>

              <div className="bignumber-values">{cobeturaFormatos}</div>

              <div className="bignumber-footer">
                <EastOutlinedIcon
                  color="#173354"
                  sx={{ width: 16, height: 16 }}
                />
                <span>Realizado: R$ 200.000 </span>
              </div>
            </Card>

            <Card
              header={{
                hardTitle: "Cobertura Qualificada",
              }}
            >
              <div className="bignumber-subTitle">
                Melhor PDV em cobertura qualificada
              </div>

              <div className="bignumber-values">{cobeturaQualificada}</div>

              <div className="bignumber-footer">
                <EastOutlinedIcon
                  color="#173354"
                  sx={{ width: 16, height: 16 }}
                />
                <span>Realizado: R$ 209.000 </span>
              </div>
            </Card>

            <Card
              header={{
                hardTitle: "Sell Out Total",
              }}
            >
              <div className="bignumber-subTitle">
                Melhor PDV em cobertura qualificada
              </div>

              <div className="bignumber-values">{sellOutTotal}</div>

              <div className="bignumber-footer">
                <EastOutlinedIcon
                  color="#173354"
                  sx={{ width: 16, height: 16 }}
                />
                <span>Realizado: R$ 134.301 </span>
              </div>
            </Card>
          </Grid>

          <Grid className="contianer-tables">
            <Card
              app={app}
              header={{
                hardTitle: "Distribuidores com Maior Potencial",
              }}
            >
              <p className="card-subTitle">
                Perfomance abaixo da média dos últimos 3 meses
              </p>
              <NativeObject
                app={app}
                key={NATIVE_OBJECTS.DISTRI}
                reference={{ id: NATIVE_OBJECTS.DISTRI }}
                style={{
                  width: "100%",
                  height: "587px",
                }}
              />
            </Card>

            <Card
              app={app}
              header={{
                hardTitle: "Participação de Produtos",
              }}
            >
              <p className="card-subTitle">
                Produtos que têm o melhor desempenho em cada PDV
              </p>
              <NativeObject
                app={app}
                key={NATIVE_OBJECTS.PARTIC}
                reference={{ id: NATIVE_OBJECTS.PARTIC }}
                style={{
                  width: "100%",
                  height: "587px",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

InsightsDesktop.defaultProps = {
  app: null,
};

export default InsightsDesktop;
